export enum ModalAction {
    OPEN,
    CLOSE
}

export enum ModalType {
    SIGN_UP,
    LOGIN,
    CONFIRM_EMAIL,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    MEDIA_UPLOAD,
    PROCESS_COMPLETE,
    PROCESS_PUBLISH,
    CONTACT_CREATOR,
    CONFIRMATION
}

export enum Process_Complete_Mode {
    CREATION = 1,
    EXECUTION = 2
}

export interface ModalContext {
    modalType: ModalType,
    modalAction: ModalAction,
    parameters: any[],
    leaveOthers?: boolean
}

export interface ModalResult {
    modalType: ModalType,
    result: any
}

export interface ModalComponent {
    openModal(...args: any[]): void,
    closeModal(): void
}

export interface ModalItem {
    modalType: ModalType,
    contentModal: ModalComponent
}

export enum MediaModalModes {
    IMAGE = 1,
    VIDEO = 2,
    IMAGE_AND_VIDEO = 3
}

export interface StepType {
    stepTypeId: number,
    name: string,
    imageUrl: string
}

export interface StepTypePrefix {
    stepTypePrefixId: number,
    stepTypeId: number,
    text: string
}

export interface PagedList<T> {
    items: Array<T>;
    pageNumber: number;
    pageSize: number;
    totalItemsCount: number;
}

export enum Languages {
    enUS = 1,
    enUS_Description = <any>'en-US',
    heIL = 2,
    heIL_Description = <any>'he-IL'
}

export class EnumHelper {
    static GetDescription(e: any, id: number): string {
        return e[e[id].toString() + '_Description'];
    }
}

export interface NewsFeedMessage {
    order: number;
    messageHtml: string;
    imageSmallUrl: string;
}


// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/models/shared.model.ts